export default "__VITE_ASSET__CQLP2O$4__"